export default __webpack_public_path__ + "static/media/4543.de341e75.png";